// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { basketSelectedBonusChange, basketItemSelectedBonusChange } from '../../actions/basket';
import useMergeProps from '../../hooks/useMergeProps';

import BasketBonusList from './BasketBonusList';
import makeSelectBonusListProps from './BasketBonusList.selector';

type BasketBonusListContainerProps = {
  className?: string;
  itemId?: number;
};

const BasketBonusListContainer = ({ itemId: itemIdFromProps, ...ownProps }: BasketBonusListContainerProps) => {
  const dispatch = useDispatch();

  const selector = useMemo(() => makeSelectBonusListProps(), []);
  const selectorProps = useMemo(() => ({ itemId: itemIdFromProps }), [itemIdFromProps]);
  const { itemId, ...selectedProps } = useSelector((state) => selector(state, selectorProps));

  const onSelectBonus = useCallback(
    (promotionId) => {
      if (itemId) {
        dispatch(
          basketItemSelectedBonusChange({
            oddId: itemId,
            promotionId,
          }),
        );
      } else {
        dispatch(
          basketSelectedBonusChange({
            promotionId,
          }),
        );
      }
    },
    [dispatch, itemId],
  );

  const otherProps = useMemo(
    () => ({
      onSelectBonus,
    }),
    [onSelectBonus],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <BasketBonusList {...enhancedProps} />;
};

export default BasketBonusListContainer;
